export const GET_ISSUED_PAGE_DATA_START = 'GET_ISSUED_PAGE_DATA_START';
export const GET_ISSUED_PAGE_DATA_SUCCESS = 'GET_ISSUED_PAGE_DATA_SUCCESS';
export const GET_ISSUED_PAGE_DATA_FAIL = 'GET_ISSUED_PAGE_DATA_FAIL';

export const GET_ISSUED_CARD_START = 'GET_ISSUED_CARD_START';
export const GET_ISSUED_CARD_SUCCESS = 'GET_ISSUED_CARD_SUCCESS';
export const GET_ISSUED_CARD_FAIL = 'GET_ISSUED_CARD_FAIL';

export const SET_ISSUED_CARD_AS_EXPIRED = 'SET_ISSUED_CARD_AS_EXPIRED';
